(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
class BundleBuilderElement extends HTMLElement {
  constructor() {
    super();
    this.slots = [];
    this.products = [];
    this.activeSlotIndex = 0;
    this.bundleId = null;
    this.isLoading = false;
    this.isPanelOpen = false;
  }

  connectedCallback() {
    this.bundleType = this.dataset.bundleType || 'custom-box';
    this.minItems = parseInt(this.dataset.minItems) || 4;
    this.maxItems = parseInt(this.dataset.maxItems) || 8;
    this.bundlePrice = parseFloat(this.dataset.bundlePrice) || 0;
    this.storageKey = `bundle_builder_${this.bundleType}`;

    this.initializeSlots();
    this.cacheElements();
    this.bindEvents();
    this.loadFromStorage();
    this.initMobileSheet();
    this.updateUI();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  initializeSlots() {
    this.slots = Array(this.maxItems).fill(null);
    this.bundleId = this.generateBundleId();
  }

  cacheElements() {
    this.slotElements = this.querySelectorAll('[data-bundle-slot]');
    this.productCards = this.querySelectorAll('[data-bundle-product]');
    this.progressText = this.querySelector('[data-progress-text]');
    this.progressFill = this.querySelector('[data-progress-fill]');
    this.progressContainer = this.querySelector('[data-progress]');
    this.totalPrice = this.querySelector('[data-total-price]');
    this.savingsElement = this.querySelector('[data-savings]');
    this.addToCartBtn = this.querySelector('[data-add-bundle]');
    this.clearBtn = this.querySelector('[data-clear-bundle]');
    this.filterBtns = this.querySelectorAll('[data-filter]');

    // Mobile elements (outside the custom element, so use closest parent)
    const root = this.closest('.bundle-builder--root');
    if (root) {
      this.mobileSheet = root.querySelector('[data-mobile-sheet]');
      this.mobileBar = root.querySelector('[data-mobile-bar]');
      this.mobilePanel = root.querySelector('[data-mobile-panel]');
      this.mobileSlotsContainer = root.querySelector('[data-mobile-slots]');
      this.mobileCount = root.querySelector('[data-mobile-count]');
      this.mobilePrice = root.querySelector('[data-mobile-price]');
      this.mobilePanelSlots = root.querySelector('[data-mobile-panel-slots]');
      this.mobileProgressText = root.querySelector('[data-mobile-progress-text]');
      this.mobileProgressFill = root.querySelector('[data-mobile-progress-fill]');
      this.mobileTotalPrice = root.querySelector('[data-mobile-total-price]');
      this.mobileSavings = root.querySelector('[data-mobile-savings]');
      this.mobileAddBtn = root.querySelector('[data-mobile-add-bundle]');
      this.mobileCloseBtn = root.querySelector('[data-close-panel]');
    }
  }

  bindEvents() {
    this.slotElements.forEach((slot, index) => {
      slot.addEventListener('click', (e) => {
        if (e.target.closest('[data-remove-slot]')) {
          this.removeFromSlot(index);
        } else {
          this.setActiveSlot(index);
        }
      });
    });

    this.productCards.forEach(card => {
      card.addEventListener('click', () => {
        if (card.dataset.unavailable === 'true' || card.dataset.available !== 'true') {
          return;
        }
        const productData = this.getProductDataFromCard(card);
        this.addToBundle(productData);
      });
    });

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', () => this.addBundleToCart());
    }

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', () => this.clearBundle());
    }

    this.filterBtns.forEach(btn => {
      btn.addEventListener('click', () => this.filterProducts(btn.dataset.filter));
    });
  }

  unbindEvents() {}

  generateBundleId() {
    return `${this.bundleType}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  getProductDataFromCard(card) {
    return {
      id: card.dataset.variantId,
      productId: card.dataset.productId,
      handle: card.dataset.handle,
      title: card.dataset.title,
      variantTitle: card.dataset.variantTitle,
      price: parseFloat(card.dataset.price) || 0,
      image: card.dataset.image,
      available: card.dataset.available === 'true'
    };
  }

  setActiveSlot(index) {
    this.activeSlotIndex = index;
    this.slotElements.forEach((slot, i) => {
      slot.dataset.active = i === index ? 'true' : 'false';
    });
  }

  addToBundle(productData) {
    if (!productData.available) return;

    let targetIndex = this.slots.findIndex(slot => slot === null);
    if (targetIndex === -1) {
      targetIndex = this.activeSlotIndex;
    }

    this.slots[targetIndex] = productData;

    const nextEmpty = this.slots.findIndex((slot, i) => i > targetIndex && slot === null);
    if (nextEmpty !== -1) {
      this.setActiveSlot(nextEmpty);
    } else {
      const firstEmpty = this.slots.findIndex(slot => slot === null);
      if (firstEmpty !== -1) {
        this.setActiveSlot(firstEmpty);
      }
    }

    this.saveToStorage();
    this.updateUI();
    this.dispatchEvent(new CustomEvent('bundle:updated', { bubbles: true, detail: { slots: this.slots } }));
  }

  removeFromSlot(index) {
    this.slots[index] = null;
    this.setActiveSlot(index);
    this.saveToStorage();
    this.updateUI();
  }

  clearBundle() {
    this.slots = Array(this.maxItems).fill(null);
    this.bundleId = this.generateBundleId();
    this.activeSlotIndex = 0;
    this.clearStorage();
    this.updateUI();
    this.setActiveSlot(0);
  }

  filterProducts(filter) {
    this.filterBtns.forEach(btn => {
      btn.dataset.active = btn.dataset.filter === filter ? 'true' : 'false';
    });

    this.productCards.forEach(card => {
      if (filter === 'all') {
        card.style.display = '';
      } else {
        const tags = (card.dataset.tags || '').toLowerCase();
        const type = (card.dataset.productType || '').toLowerCase();
        const matchesFilter = tags.includes(filter.toLowerCase()) || type.includes(filter.toLowerCase());
        card.style.display = matchesFilter ? '' : 'none';
      }
    });
  }

  updateUI() {
    this.slotElements.forEach((slot, index) => {
      const product = this.slots[index];
      slot.dataset.filled = product ? 'true' : 'false';

      const imageEl = slot.querySelector('[data-slot-image]');
      const titleEl = slot.querySelector('[data-slot-title]');

      if (product) {
        if (imageEl) {
          imageEl.innerHTML = product.image ? `<img src="${product.image}" alt="${product.title}">` : '';
        }
        if (titleEl) {
          titleEl.textContent = product.title;
        }
      } else {
        if (imageEl) imageEl.innerHTML = '';
        if (titleEl) titleEl.textContent = '';
      }
    });

    const filledCount = this.slots.filter(slot => slot !== null).length;
    const progressPercent = Math.min((filledCount / this.minItems) * 100, 100);
    const meetsMinimum = filledCount >= this.minItems;
    const isFull = filledCount === this.maxItems;

    if (this.progressText) {
      if (filledCount === 0) {
        this.progressText.textContent = `Select at least ${this.minItems} items (up to ${this.maxItems})`;
      } else if (meetsMinimum) {
        this.progressText.textContent = `${filledCount} selected${!isFull ? ` (can add ${this.maxItems - filledCount} more)` : ''}`;
      } else {
        this.progressText.textContent = `${filledCount} of ${this.minItems} minimum selected`;
      }
    }
    if (this.progressFill) {
      this.progressFill.style.width = `${progressPercent}%`;
    }
    if (this.progressContainer) {
      this.progressContainer.dataset.complete = meetsMinimum ? 'true' : 'false';
    }

    const itemsTotal = this.slots.reduce((sum, slot) => sum + (slot ? slot.price : 0), 0);

    if (this.totalPrice) {
      const displayPrice = this.bundlePrice > 0 ? this.bundlePrice : itemsTotal;
      this.totalPrice.textContent = this.formatMoney(displayPrice * 100);
    }

    if (this.savingsElement && this.bundlePrice > 0 && meetsMinimum) {
      const savings = itemsTotal - this.bundlePrice;
      if (savings > 0) {
        this.savingsElement.textContent = `You save ${this.formatMoney(savings * 100)}!`;
        this.savingsElement.style.display = '';
      } else {
        this.savingsElement.style.display = 'none';
      }
    } else if (this.savingsElement) {
      this.savingsElement.style.display = 'none';
    }

    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = !meetsMinimum;
      if (meetsMinimum) {
        this.addToCartBtn.textContent = `Add Bundle to Cart (${filledCount} items)`;
      } else {
        this.addToCartBtn.textContent = `Select ${this.minItems - filledCount} more`;
      }
    }

    this.productCards.forEach(card => {
      const variantId = card.dataset.variantId;
      const isInBundle = this.slots.some(slot => slot && slot.id === variantId);
      card.dataset.selected = isInBundle ? 'true' : 'false';
    });

    // Update mobile UI
    this.updateMobileUI();
  }

  async addBundleToCart() {
    const filledSlots = this.slots.filter(slot => slot !== null);
    if (filledSlots.length < this.minItems) return;

    this.isLoading = true;
    if (this.addToCartBtn) {
      this.addToCartBtn.dataset.loading = 'true';
      this.addToCartBtn.textContent = 'Adding...';
    }

    try {
      const items = filledSlots.map((slot, index) => ({
        id: parseInt(slot.id),
        quantity: 1,
        properties: {
          '_bundle_type': this.bundleType,
          '_bundle_id': this.bundleId,
          '_bundle_position': `${index + 1} of ${this.maxItems}`,
          '_bundle_name': this.dataset.bundleName || 'Custom Bundle'
        }
      }));

      // Collect section IDs from cart-items-component elements (for cart drawer refresh)
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];
      cartItemsComponents.forEach(item => {
        if (item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          sections: sectionIds.join(',')
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Cart add error:', response.status, errorData);
        throw new Error(errorData.description || errorData.message || 'Failed to add bundle to cart');
      }

      const responseData = await response.json();
      this.clearBundle();

      // Fetch updated cart to get total item count
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await cartResponse.json();

      // Dispatch cart:update event with sections data (Horizon's event system)
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'bundle-builder',
          data: {
            source: 'bundle-builder',
            itemCount: cart.item_count,
            sections: responseData.sections || {}
          }
        }
      }));

      // Open cart drawer
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      const message = error.message || 'There was an error adding the bundle to your cart.';
      alert(message + ' Please refresh the page and try again.');
    } finally {
      this.isLoading = false;
      if (this.addToCartBtn) {
        this.addToCartBtn.dataset.loading = 'false';
        this.updateUI();
      }
    }
  }

  saveToStorage() {
    try {
      const data = { slots: this.slots, bundleId: this.bundleId, bundleType: this.bundleType, timestamp: Date.now() };
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    } catch (e) {
      console.warn('Could not save bundle to localStorage:', e);
    }
  }

  loadFromStorage() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        const data = JSON.parse(stored);
        const maxAge = 24 * 60 * 60 * 1000;
        if (data.bundleType === this.bundleType && (Date.now() - data.timestamp) < maxAge) {
          this.slots = data.slots || Array(this.maxItems).fill(null);
          this.bundleId = data.bundleId || this.generateBundleId();
          while (this.slots.length < this.maxItems) this.slots.push(null);
          this.slots = this.slots.slice(0, this.maxItems);
        }
      }
    } catch (e) {
      console.warn('Could not load bundle from localStorage:', e);
    }
  }

  clearStorage() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {
      console.warn('Could not clear bundle from localStorage:', e);
    }
  }

  // Mobile Sheet Methods
  initMobileSheet() {
    if (!this.mobileSheet) return;

    this.buildMiniSlots();
    this.bindMobileEvents();
  }

  buildMiniSlots() {
    if (!this.mobileSlotsContainer) return;

    // Show up to 4 mini slots in the bar
    const slotsToShow = Math.min(4, this.maxItems);
    this.mobileSlotsContainer.innerHTML = '';

    for (let i = 0; i < slotsToShow; i++) {
      const slot = document.createElement('div');
      slot.className = 'bundle-builder--mobile-bar-slot';
      slot.dataset.index = i;
      slot.dataset.filled = 'false';
      this.mobileSlotsContainer.appendChild(slot);
    }
  }

  bindMobileEvents() {
    // Bar click to open panel
    if (this.mobileBar) {
      this.mobileBar.addEventListener('click', () => this.openMobilePanel());
    }

    // Close button
    if (this.mobileCloseBtn) {
      this.mobileCloseBtn.addEventListener('click', () => this.closeMobilePanel());
    }

    // Panel backdrop click
    if (this.mobilePanel) {
      this.mobilePanel.addEventListener('click', (e) => {
        if (e.target === this.mobilePanel) {
          this.closeMobilePanel();
        }
      });

      // Handle cancel event (ESC key)
      this.mobilePanel.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.closeMobilePanel();
      });
    }

    // Panel slot remove buttons
    if (this.mobilePanelSlots) {
      this.mobilePanelSlots.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-remove-slot]');
        if (removeBtn) {
          const slot = removeBtn.closest('[data-bundle-slot]');
          if (slot) {
            const index = parseInt(slot.dataset.bundleSlot);
            this.removeFromSlot(index);
          }
        }
      });
    }

    // Mobile add to cart button
    if (this.mobileAddBtn) {
      this.mobileAddBtn.addEventListener('click', () => {
        this.closeMobilePanel();
        this.addBundleToCart();
      });
    }

    // Swipe down to close
    this.setupSwipeToClose();
  }

  setupSwipeToClose() {
    if (!this.mobilePanel) return;

    let startY = 0;
    let currentY = 0;
    let isDragging = false;

    const header = this.mobilePanel.querySelector('.bundle-builder--mobile-panel-header');
    if (!header) return;

    header.addEventListener('touchstart', (e) => {
      startY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    header.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentY = e.touches[0].clientY;
      const deltaY = currentY - startY;

      if (deltaY > 0) {
        this.mobilePanel.style.transform = `translateY(${deltaY}px)`;
      }
    }, { passive: true });

    header.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;

      const deltaY = currentY - startY;
      this.mobilePanel.style.transform = '';

      if (deltaY > 80) {
        this.closeMobilePanel();
      }
    });
  }

  openMobilePanel() {
    if (!this.mobilePanel || this.isPanelOpen) return;

    this.isPanelOpen = true;
    this.mobileBar.setAttribute('aria-expanded', 'true');
    this.mobilePanel.showModal();
    document.body.style.overflow = 'hidden';
    this.syncPanelSlots();
  }

  closeMobilePanel() {
    if (!this.mobilePanel || !this.isPanelOpen) return;

    this.mobilePanel.classList.add('closing');

    this.mobilePanel.addEventListener('animationend', () => {
      this.mobilePanel.classList.remove('closing');
      this.mobilePanel.close();
      this.isPanelOpen = false;
      this.mobileBar.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }, { once: true });
  }

  syncPanelSlots() {
    if (!this.mobilePanelSlots) return;

    const panelSlots = this.mobilePanelSlots.querySelectorAll('[data-bundle-slot]');

    panelSlots.forEach((slot, index) => {
      const product = this.slots[index];
      slot.dataset.filled = product ? 'true' : 'false';

      const imageEl = slot.querySelector('[data-slot-image]');
      const titleEl = slot.querySelector('[data-slot-title]');

      if (product) {
        if (imageEl) {
          imageEl.innerHTML = product.image ? `<img src="${product.image}" alt="${product.title}">` : '';
        }
        if (titleEl) {
          titleEl.textContent = product.title;
        }
      } else {
        if (imageEl) imageEl.innerHTML = '';
        if (titleEl) titleEl.textContent = '';
      }
    });
  }

  updateMobileUI() {
    if (!this.mobileSheet) return;

    const filledCount = this.slots.filter(slot => slot !== null).length;
    const meetsMinimum = filledCount >= this.minItems;
    const isFull = filledCount === this.maxItems;

    // Update mini slots in bar
    const miniSlots = this.mobileSlotsContainer?.querySelectorAll('.bundle-builder--mobile-bar-slot');
    if (miniSlots) {
      miniSlots.forEach((slot, index) => {
        const product = this.slots[index];
        slot.dataset.filled = product ? 'true' : 'false';
        slot.innerHTML = product && product.image ? `<img src="${product.image}" alt="${product.title}">` : '';
      });
    }

    // Update bar count and price
    if (this.mobileCount) {
      this.mobileCount.textContent = `${filledCount} of ${this.minItems} items`;
    }

    if (this.mobileBar) {
      this.mobileBar.dataset.complete = meetsMinimum ? 'true' : 'false';
    }

    const itemsTotal = this.slots.reduce((sum, slot) => sum + (slot ? slot.price : 0), 0);
    const displayPrice = this.bundlePrice > 0 ? this.bundlePrice : itemsTotal;

    if (this.mobilePrice) {
      this.mobilePrice.textContent = this.formatMoney(displayPrice * 100);
    }

    // Update panel progress
    const progressPercent = Math.min((filledCount / this.minItems) * 100, 100);

    if (this.mobileProgressText) {
      if (filledCount === 0) {
        this.mobileProgressText.textContent = `Select at least ${this.minItems} items`;
      } else if (meetsMinimum) {
        this.mobileProgressText.textContent = `${filledCount} selected${!isFull ? ` (can add ${this.maxItems - filledCount} more)` : ''}`;
      } else {
        this.mobileProgressText.textContent = `${filledCount} of ${this.minItems} minimum selected`;
      }
    }

    if (this.mobileProgressFill) {
      this.mobileProgressFill.style.width = `${progressPercent}%`;
    }

    // Update panel total price
    if (this.mobileTotalPrice) {
      this.mobileTotalPrice.textContent = this.formatMoney(displayPrice * 100);
    }

    // Update panel savings
    if (this.mobileSavings && this.bundlePrice > 0 && meetsMinimum) {
      const savings = itemsTotal - this.bundlePrice;
      if (savings > 0) {
        this.mobileSavings.textContent = `You save ${this.formatMoney(savings * 100)}!`;
        this.mobileSavings.style.display = '';
      } else {
        this.mobileSavings.style.display = 'none';
      }
    } else if (this.mobileSavings) {
      this.mobileSavings.style.display = 'none';
    }

    // Update panel add button
    if (this.mobileAddBtn) {
      this.mobileAddBtn.disabled = !meetsMinimum;
      if (meetsMinimum) {
        this.mobileAddBtn.textContent = `Add Bundle to Cart (${filledCount} items)`;
      } else {
        this.mobileAddBtn.textContent = `Select ${this.minItems - filledCount} more`;
      }
    }

    // Sync panel slots if open
    if (this.isPanelOpen) {
      this.syncPanelSlots();
    }
  }

  formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }
}

if (!customElements.get('bundle-builder-element')) {
  customElements.define('bundle-builder-element', BundleBuilderElement);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
